import { Injectable } from '@angular/core';
import posthog from 'posthog-js';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class PosthogService {
  public startTracking() {
    const { apiKey, apiHost } = environment.posthog;

    // if no apiKey is provided, do not initialise — no events will be tracked
    if (apiKey) {
      posthog.init(apiKey, {
        api_host: apiHost,
        capture_pageleave: true,
        autocapture: false,
      });

      posthog.register({
        environment: environment.name,
        app_release: environment.posthog.app_release,
      });
    }
  }

  public setUserProperties(userId: string, traits?: Record<string, unknown>) {
    posthog.identify(userId, traits);
  }

  public unsetUserProperties() {
    posthog.reset();
  }
}
